import { initials } from '@/lib/crm'
import { cn } from '@/lib/utils'

interface InitialsAvatarProps {
    name: string
    className?: string
}

const TONES = [
    'bg-(--tag-blue-bg) text-(--tag-blue-text)',
    'bg-(--tag-purple-bg) text-(--tag-purple-text)',
    'bg-(--tag-green-bg) text-(--tag-green-text)',
    'bg-(--tag-orange-bg) text-(--tag-orange-text)',
    'bg-(--tag-red-bg) text-(--tag-red-text)',
    'bg-(--tag-yellow-bg) text-(--tag-yellow-text)'
]

export default function InitialsAvatar({ name, className }: InitialsAvatarProps) {
    const seed = Array.from(name).reduce((sum, char) => sum + char.charCodeAt(0), 0)

    return (
        <span
            aria-hidden
            className={cn(
                'caption-style flex size-6 shrink-0 items-center justify-center rounded-full font-medium shadow-[0px_0px_0px_1px_rgba(255,255,255,0.06)]',
                TONES[seed % TONES.length],
                className
            )}
        >
            {initials(name)}
        </span>
    )
}
